import script from "./CustomBadge.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomBadge.vue?vue&type=script&setup=true&lang=ts"

import "./CustomBadge.vue?vue&type=style&index=0&id=e471b46e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e471b46e"]])

export default __exports__